// app/javascript/controllers/age_verification_controller.js
import { Controller } from "stimulus";
import Cookies from 'js-cookie'
import { Modal } from 'bootstrap'

export default class extends Controller {
  static targets = ["modal"];

  connect(event) {
    if (!Cookies.get('age_verified')) {
     this.modal = new Modal(this.element,{
      backdrop: 'static',
      keyboard: false
    });
     this.modal.show();
   }
  }

  verify() {
    Cookies.set('age_verified', 'true', { expires: 365 })
    this.modal.hide();
  }

  exit() {
    window.location.href = "https://www.google.com";
  }
}
